import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { EnggProcureIP, SalesOrder, SaveStatusObj, SOModule, SaveEventType, ActualDateChange, ActualDateToken, PlannedDateToken, ValidationItem, ValidationSummary, SSOStatus, EnggProcFileUploads, GenFileUploads } from '../../../shared/misc-classes';
import { DataService } from '../../../shared/dataservice.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';

@Component({
  selector: 'engg-procure',
  templateUrl: './engg-procure.component.html',
  styleUrls: ['./engg-procure.component.css']
})
export class EnggProcureComponent implements OnInit, OnChanges {

  @Input() enggProcureObj: EnggProcureIP;
  @Input() soLockObtained:boolean;
  @Input() loadCounter:SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() showEnggFileUploadManager: EventEmitter<EnggProcFileUploads> = new EventEmitter();
  @Output() showFileManager: EventEmitter<GenFileUploads> = new EventEmitter();
  disableForm: boolean = true;
  public _SSOStatus = SSOStatus;

  Hvr:any = {};

  modifyPlanDate:boolean = false;
  modifyReqDate:boolean = false;
  inputDisableMessage:string = 'This form is not yet enabled';
  constructor(public _dataService: DataService,public dialog: MatDialog) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
    this.ngOnChanges();
  }
  ngOnChanges() {
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    // else if (!this.enggProcureObj.isProjectLive) {
    //   this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    // }
    else if (!this.enggProcureObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasEnggProcurementEditAccess(this.enggProcureObj)) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
    
    this.enggProcureObj.enggProcFile.headerStr = "C40 Files"  + " - " + this.enggProcureObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggProcureObj.parentSubSORef.subOrderNoId;
    this.enggProcureObj.enggProcFile.disableUpload = this.disableForm;
    this.enggProcureObj.c50Files.headerStr = "C50 Files"  + " - " + this.enggProcureObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggProcureObj.parentSubSORef.subOrderNoId;
    this.enggProcureObj.c50Files.disableUpload = this.disableForm;
    this.enggProcureObj.c60Files.headerStr = "C60 Files"  + " - " + this.enggProcureObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggProcureObj.parentSubSORef.subOrderNoId;
    this.enggProcureObj.c60Files.disableUpload = this.disableForm;
    this.enggProcureObj.longLeadFiles.headerStr = "Long Lead Files"  + " - " + this.enggProcureObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggProcureObj.parentSubSORef.subOrderNoId;
    this.enggProcureObj.longLeadFiles.disableUpload = this.disableForm;
    this.enggProcureObj.asBuiltDrawFile.headerStr = "AS Built Drawing Mechanical Files" + " - " + this.enggProcureObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggProcureObj.parentSubSORef.subOrderNoId;
    this.enggProcureObj.asBuiltDrawFile.disableUpload = this.disableForm;
    this.enggProcureObj.asBuiltDrawElecFiles.headerStr = "AS Built Drawing Electrical Files" + " - " + this.enggProcureObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggProcureObj.parentSubSORef.subOrderNoId;
    this.enggProcureObj.asBuiltDrawElecFiles.disableUpload = this.disableForm;
    this.enggProcureObj.mechDesignChangeNoteFiles.headerStr = "Mechanical Design Change Note Files" + " - " + this.enggProcureObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggProcureObj.parentSubSORef.subOrderNoId;
    this.enggProcureObj.mechDesignChangeNoteFiles.disableUpload = this.disableForm;
    this.enggProcureObj.elecDesignChangeNoteFiles.headerStr = "Electrical Design Change Note Files" + " - " + this.enggProcureObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggProcureObj.parentSubSORef.subOrderNoId;
    this.enggProcureObj.elecDesignChangeNoteFiles.disableUpload = this.disableForm;
  }


  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.enggProcureObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.enggProcureObj[_actTokenKeyName].actualDate;
    this.enggProcureObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.enggProcureObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.enggProcureObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.enggProcureObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.enggProcureObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.enggProcureObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.enggProcureObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.enggProcureObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }
  showSsoPOPlanningValidation(){
      let _validList:Array<ValidationItem> = [
        new ValidationItem('"C40 Actual Date" or "Long Lead Release Actual Date"', (this.enggProcureObj.actualC40Date || this.enggProcureObj.actualLongLeadReleaseDate ? true : false)," required for PO & Planning." )
      ] ;

      let vSummaryObj:ValidationSummary = new ValidationSummary("Validation Summary.",_validList);
      
      this.dialog.open(ValidationDialog, {
        width: '50%',
        data: vSummaryObj
      });
  }

  saveSso(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.PO | SSOStatus.Planning){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }
  deleteSSo(_deleteSO:boolean){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }
  }
  enggFilesUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showEnggFileUploadManager.emit(this.enggProcureObj.enggProcFile);
  }
  c50FilesUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showEnggFileUploadManager.emit(this.enggProcureObj.c50Files);
  }
  c60FilesUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showEnggFileUploadManager.emit(this.enggProcureObj.c60Files);
  }
  longLeadFilesUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showEnggFileUploadManager.emit(this.enggProcureObj.longLeadFiles);
  }
  asBuiltDrawFilesUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showEnggFileUploadManager.emit(this.enggProcureObj.asBuiltDrawFile);
  }
  asBuiltDrawElecUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showFileManager.emit(this.enggProcureObj.asBuiltDrawElecFiles);
  }
  mechChangeNoteUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showFileManager.emit(this.enggProcureObj.mechDesignChangeNoteFiles);
  }
  elecChangeNoteUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showFileManager.emit(this.enggProcureObj.elecDesignChangeNoteFiles);
  }

}
